var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',[_c('b',[_vm._v("小熊后台")]),_vm._v(" v1.0.0 ")])}
var staticRenderFns = []

export { render, staticRenderFns }